// extracted by mini-css-extract-plugin
export default {"date-container":"ALQLki","dateContainer":"ALQLki","dateFont":"tN7ge3"};